import { Controller } from "react-hook-form";
import TextField from "../../../text-field/text-field";
import { InputAdornment } from "@mui/material";


interface DynamicCurrencyProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  currency?: string;
  currencySymbol?: string;
}
const DynamicCurrency = (props: DynamicCurrencyProps) => {
    return (
        <Controller
            control={props.formControl}
            name={`${props.fieldArrayName}.${props.name}`}
            render={({ field, fieldState }) => (
                <TextField
                    {...field}
                    name={`${props.fieldArrayName}.${props.name}`}
                    fullWidth
                    label={props.label}
                    defaultValue={props.default_value.replace(/[^0-9]/g, "")}
                    placeholder={props.placeholder}
                    multiline={props.is_multiline || false}
                    disabled={props.disabled}
                    required={props.is_required}
                    inputProps={{
                        step: props?.float_step || "0" , 
                        min : props.min_length  || 0 , 
                        max : props.max_length || 1000 ,
                        inputMode: 'numeric',
                        pattern : `${props.is_negative}` ? '-?[0-9]*' : '[0-9]*' , 
                        
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment
                                position="start"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRight: '1px solid rgba(0, 0, 0, 0.23)',
                                    width: 50,
                                    height: '100%',
                                    borderBottomLeftRadius: 4, 
                                    borderTopLeftRadius: 4,
                                }}
                            >
                                {(props.currencyType !== null ? props.currencyType  :  "-")}
                            </InputAdornment>
                        )

                    }}

                    error={Boolean(fieldState.error?.message)}
                    helperText={fieldState.error?.message || ""}
                    onBlur = {field.onBlur}
                 onChange ={(e : any) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g , "");
                    field.onChange(numericValue)
                 }}
                />
            )}
        />
    )
}
export { DynamicCurrency };
export default DynamicCurrency;



